// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:45:36

export default {
  "id": "sprunki-beats",
  "slug": "sprunki-beats",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/291267b4a60e40f9951be1d193dab421-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/291267b4a60e40f9951be1d193dab421/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Beats",
      "description": "Sprunki Beats takes you on a rhythmic adventure through four exciting levels, featuring both horror and normal modes. Explore unique environments as you master the beats and uncover secrets. Fans of Sprunki will love the thrilling challenges, including hints of Mustard mods and connections to the iconic Phase 5. \n\nWhat is Sprunki? \nIt’s the ultimate rhythm game experience, blending mystery and excitement. Dive into Sprunki Beats and prove your skills in this must-play journey!",
      "instructions": "On Desktop:\nUse MOUSE and LEFT-CLICK\n\nOn Mobile:\nUse Touch Controls",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2d",
        "challenge",
        "customize",
        "music",
        "musical"
      ]
    },
    "zh-CN": {
      "title": "斯普林基打击乐",
      "description": "Sprunki Beats带你穿越四个激动人心的关卡，包含恐怖模式和普通模式。在掌握节奏的同时探索独特环境，揭示秘密。Sprunki粉丝将热爱这个充满挑战的旅程，包括Mustard模式的暗示以及与标志性的Phase 5的联系。\n\n什么是Sprunki？\n它是终极节奏游戏体验，融合神秘与激动。加入Sprunki Beats，在这场必玩旅程中证明你的技能！",
      "instructions": "在桌面版：\n使用鼠标和左键点击\n\n在移动版：\n使用触摸控制",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2D",
        "挑战",
        "定制",
        "音乐",
        "音乐性"
      ]
    },
    "zh-TW": {
      "title": "斯普恩基 擊敗",
      "description": "Sprunki Beats帶您踏上一場節奏冒險之旅，共有四個刺激的關卡，融合了恐怖和普通模式。當您精通節奏並揭開秘密時，探索獨特環境。Sprunki粉絲將喜愛這些刺激挑戰，包括Mustard模組的暗示以及與經典的第5階段的聯繫。\n\n什麼是Sprunki？\n它是無與倫比的節奏遊戲體驗，融合神秘與興奮。投入Sprunki Beats，證明您的技能於這場必玩之旅中！",
      "instructions": "在桌面版：\n使用滑鼠和左鍵點擊\n\n在行動版：\n使用觸控控制",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "挑戰",
        "客製化",
        "音樂",
        "音樂性"
      ]
    },
    "zh-HK": {
      "title": "斯普林基音樂節拍",
      "description": "Sprunki Beats 帶你進行一場節奏冒險，通過四個刺激的關卡，包含恐怖和普通模式。在掌握節奏並揭開秘密的同時，探索獨特的环境。Sprunki 粉絲將喜愛這些刺激的挑戰，包括 Mustard mod 的暗示以及與經典的 Phase 5 的聯繫。\n\n什麼是 Sprunki？\n它是無敵的節奏遊戲體驗，結合神秘與刺激。投入 Sprunki Beats，在這場必玩之旅中證明你的技巧！",
      "instructions": "在桌上型電腦：\n使用滑鼠及左鍵點擊\n\n在行動裝置：\n使用觸控控制",
      "genres": [
        "冒險"
      ],
      "tags": [
        "二維",
        "挑戰",
        "客製化",
        "音樂",
        "音樂節奏"
      ]
    },
    "ja": {
      "title": "スプリンクティビーツ",
      "description": "Sprunki Beatsは、ホラーと通常モードの両方を特徴とする4つの刺激的なレベルを通じてリズムの冒険を提供します。リズムをマスターしながらユニークな環境を探検し、秘密を解き明かしましょう。Sprunkiのファンは、マスタードモッドのヒントや象徴的なフェーズ5との関連を含むスリリングな挑戦を楽しんでいただけます。\n\n何がSprunkiなのか？\nそれは、ミステリーと興奮を融合した究極のリズムゲーム体験です。Sprunki Beatsに没頭し、この必須の旅であなたのスキルを証明しましょう！",
      "instructions": "デスクトップ:\nマウスと左クリックを使用\n\nモバイル:\nタッチコントロールを使用",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2D",
        "挑戦",
        "カスタマイズ",
        "音楽",
        "音楽的"
      ]
    },
    "ko": {
      "title": "스프랑키 비츠",
      "description": "Sprunki Beats는 네 가지 흥미진진한 레벨을 통해 리듬을 타는 모험을 제공하며, 공포와 일반 모드를 모두 특징으로 합니다. 비밀을 발견하며 리듬을 마스터하고 독특한 환경을 탐험하세요. Sprunki 팬들은 Mustard 모드와 iconic Phase 5와의 연결을 포함한 스릴러적인 도전을 사랑할 것입니다.\n\nWhat is Sprunki?\nSprunki는 미스터리와 흥미를 결합한 최종 리듬 게임 경험입니다. Sprunki Beats에 빠져들어 이 필수 플레이 여정에서 당신의 기술을 입증하세요!",
      "instructions": "데스크톱:\n마우스와 왼쪽 클릭 사용\n\n모바일:\n터치 컨트롤 사용",
      "genres": [
        "모험"
      ],
      "tags": [
        "2D",
        "도전",
        "맞춤형",
        "음악",
        "음악적"
      ]
    },
    "fr": {
      "title": "Sprunki Beats",
      "description": "Sprunki Beats vous emmène dans une aventure rythmique à travers quatre niveaux captivants, proposant à la fois des modes horreur et normal. Explorez des environnements uniques tout en maîtrisant les beats et en découvrant des secrets. Les fans de Sprunki adoreront les défis palpitants, y compris des indices sur les mods de Moutarde et des connexions à l'icônique Phase 5.\n\nQu'est-ce que Sprunki ?\nC'est l'expérience ultime en jeu de rythme, mélangeant mystère et excitation. Plongez dans Sprunki Beats et prouvez vos compétences dans ce voyage incontournable !",
      "instructions": "Sur ordinateur :\nUtilisez la SOURIS et le CLIC GAUCHE\n\nSur mobile :\nUtilisez les COMMANDES TACTILES",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2d",
        "défi",
        "personnaliser",
        "musique",
        "musical"
      ]
    }
  }
};
